import { render, staticRenderFns } from "./Bcard.vue?vue&type=template&id=e10fc5b6"
import script from "./Bcard.vue?vue&type=script&lang=js"
export * from "./Bcard.vue?vue&type=script&lang=js"
import style0 from "./Bcard.vue?vue&type=style&index=0&id=e10fc5b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports